import { Collapse } from "bootstrap";
import { ConditionalTooltip } from "components/ConditionalTooltip";
import { useEffect, useRef } from "react";

export const PauseBanner = (props: { isPaused: boolean }) => {
    const { isPaused } = props;

    const collapseRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (collapseRef.current) {
            const collapse = new Collapse(collapseRef.current, { toggle: isPaused });

            if (isPaused) {
                collapse.show();
            } else {
                collapse.hide();
            }
        }
    }, [isPaused]);

    return (
        <div ref={collapseRef} className="collapse">
            <div className="pt-4">
                <ConditionalTooltip
                    show={true}
                    text="If all players submit replies or votes while the timer is paused, the game will continue
                                and the timer will reactivate"
                >
                    <div className="alert bg-danger mb-0 text-center text-lg-start">
                        <div className="hstack gap-3">
                            <div className="hstack d-none d-lg-flex">
                                <span className="fs-2 fas fa-pause"></span>
                            </div>

                            <div className="vstack gap-1 align-self-center">
                                <div className="d-flex flex-column flex-lg-row gap-2 gap-lg-3 align-items-lg-center justify-content-between">
                                    <div className="h5">Timer paused</div>

                                    <div className="small">You can resume playing at any time</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ConditionalTooltip>
            </div>
        </div>
    );
};
